import React from "react";
import { useTranslation } from "react-i18next";

import { SecondaryCriteria } from "@planzone/dto";
import { Button } from "@common/button";
import { Props } from "./types";
import { NumberForm } from "./numberForm";
import { TextForm } from "./textForm";
import { DateForm } from "./dateForm";
import { ListForm } from "./listForm";
import { LinkForm } from "./linkForm";
import { TypeInput } from "./typeInput";
import styles from "./styles.scss";

function canSubmit(formData: SecondaryCriteria) {
  const isList = formData.type === "list";
  const hasName = formData.name.length > 0;
  const hasOptions = formData.options.length > 0;

  return isList ? hasName && hasOptions : hasName;
}

function Form(props: Props) {
  const { t } = useTranslation();
  const { type } = props.formData;

  return (
    <div className={styles.form}>
      {props.isCreating && !props.isOption && (
        <TypeInput
          value={props.formData.type}
          input={(type) => props.edit({ ...props.formData, type })}
        />
      )}
      {type === "number" ? (
        <NumberForm {...props} />
      ) : type === "date" ? (
        <DateForm {...props} />
      ) : type === "list" ? (
        <ListForm {...props} />
      ) : type === "link" ? (
        <LinkForm {...props} />
      ) : type === "richText" ? (
        <TextForm {...props} />
      ) : (
        <TextForm {...props} />
      )}
      <div className={styles.buttons}>
        {!!props.cancel && (
          <Button type="cancel" press={props.cancel}>
            {t("secondaryCriteriaTemplate.remove")}
          </Button>
        )}
        {!!props.reset && props.hasChanged && (
          <Button type="cancel" press={props.reset}>
            {t("secondaryCriteriaTemplate.form.reset")}
          </Button>
        )}
        {!!props.remove && (
          <Button
            type="delete"
            press={() => props.remove && props.remove(props.formData)}
          >
            {t("secondaryCriteriaTemplate.remove")}
          </Button>
        )}
        {!!props.submit && (
          <Button
            type="submit"
            isDisabled={!props.hasChanged || !canSubmit(props.formData)}
            press={() => props.submit && props.submit(props.formData)}
            status={props.isRequestPending ? "pending" : "none"}
          >
            {props.isCreating
              ? t("secondaryCriteriaTemplate.add")
              : t("secondaryCriteriaTemplate.form.submit")}
          </Button>
        )}
      </div>
    </div>
  );
}

export { Form };
